import PrintDesign from './PrintDesign';

export default PrintDesign;



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/print-design/index.jsx